<template>
    <Path>
        <template v-slot:path>
            <li><router-link :to="{name: 'dashboard'}" >الصفحة الرئيسية</router-link> </li>
            <li> <span class="divider"> / </span><a href="#">عن القطاع </a> </li>
        </template>
    </Path>


    <section id="content">
        <div class="py-4 ">
            <div class="container">
                <div class="row">
                    <div class="col-12 mb-2 ">
                        <div class="row">
                            <div class="col-md-4 col-12">
                                <div class="nav flex-column nav-pills me-3 border  shadow-sm p-4 rounded-3"
                                    id="v-pills-tab" role="tablist" aria-orientation="vertical">
                                    <button class="nav-link active border-bottom" id="v-pills-home-tab"
                                        data-bs-toggle="pill" data-bs-target="#v-pills-home" type="button" role="tab"
                                        aria-controls="v-pills-home" aria-selected="true"> تعريف القطاع <i
                                            class="bi bi-chevron-left"></i></button>
                                    <button class="nav-link border-bottom" id="v-pills-profile-tab"
                                        data-bs-toggle="pill" data-bs-target="#v-pills-profile" type="button" role="tab"
                                        aria-controls="v-pills-profile" aria-selected="false">مصدرات القطاع <i
                                            class="bi bi-chevron-left"></i></button>
                                    <button class="nav-link border-bottom" id="v-pills-messages-tab"
                                        data-bs-toggle="pill" data-bs-target="#v-pills-messages" type="button"
                                        role="tab" aria-controls="v-pills-messages" aria-selected="false">الرقم القومي<i
                                            class="bi bi-chevron-left"></i></button>
                                </div>
                            </div>
                            <div class="col-md-8 col-12">
                                <div class="tab-content" id="v-pills-tabContent">
                                    <div class="tab-pane fade show active" id="v-pills-home" role="tabpanel"
                                        aria-labelledby="v-pills-home-tab" tabindex="0">
                                        <h1 class="blueFont py-3"> التعريف بالقطاع</h1>

                                        <p>
                                            أنشىء قطاع الأحوال المدنية عام 1962 كأحدى القطاعات الرئيسية التابعة لوزارة
                                            الداخلية وأسند إليها تنفيذ القانون رقم 260 لسنة 1960 ومباشرة الحالة المدنية
                                            للمواطنين وتسجيل الواقعات الحيوية الأتيه لهم:
                                            الميلاد الوفاة
                                            الزواج الطلاق
                                            كذا إصدار صور من تلك الواقعات فضلا عن إصدار بطاقات الرقم القومى وصورة القيد
                                            العائلى المميكن من واقع الحاسب الألى وتصحيح الأخطاء في واقعتي ( الميلاد -
                                            الوفاة ) وتغيير الأسماء والديانة والجنسية بعد اتخاذ الإجراءات القانونية
                                            المقرره لذلك

                                        </p>


                                        <img @click="LightBox" src="@/assets/images/Video.png" alt=""
                                            class="img-fluid py-3 pointer">
                                        <a @click="CloseDiv">
                                            <div v-if="play" id="lightbox" class="lightbox">
                                                <iframe
                                                    src="https://www.youtube.com/embed/d6MsNO-kiQc?rel=0&modestbranding=1&autohide=1&mute=1&showinfo=0&controls=1&autoplay=1"
                                                    width="560" height="315" frameborder="0" allowfullscreen>
                                                </iframe>
                                            </div>
                                            <div v-else id="lightbox" class="lightbox">

                                            </div>
                                        </a>
                                        <h1 class="blueFont py-3">تعريف عام بالخدمات:</h1>

                                        <p>
                                            يقوم قطاع الأحوال المدنية بمختلف الخدمات الخاصة بأوجه الحالة المدنية للمواطن
                                            المصري ( الميلاد والزواج والطلاق والوفاة ) وتسجيلها وإصدار الوثائق
                                            والمستندات الدالة عليها داخل وخارج البلاد وكذا تصحيح البيانات المدونة
                                            بالسجلات وتغيير الأسماء والديانة والجنسية بناء على طلب المواطن وبعد اتخاذ
                                            الإجراءات القانونية اللازمة.
                                            ويقوم قطاع الأحوال المدنية بإصدار الرقم القومي للمواطن منذ لحظة الميلاد
                                            وفيما يلي قائمة بالخدمات التي يقدمها قطاع الأحوال المدنية مقسمة طبقا
                                            لنوعياتها

                                        </p>


                                    </div>
                                    <div class="tab-pane fade" id="v-pills-profile" role="tabpanel"
                                        aria-labelledby="v-pills-profile-tab" tabindex="0">
                                        <h1 class="blueFont py-3">مصدرات القطاع</h1>
                                        <h1 class="blueFont py-3">تعريف عام بالخدمات: </h1>
                                        <p>دليل خدمات قطاع الاحوال المدنية</p>
                                        <p>
                                            ينشىء قطاع الأحوال المدنية تحديد الرقم القومى للمواطنين منذ مولدهم كما يقدم
                                            كافة الخدمات الخاصة المتعلقة بالحالة المدنية للمواطنين من حيث الميلاد
                                            والزواج والطلاق والوفاة وتسجيلها وإصدار الوثائق والمستندات الدالة عليها داخل
                                            وخارج البلاد
                                            كما يقوم القطاع بتصحيح البيانات المدونة بالسجلات بناء على طلب المواطن وبعد
                                            استيفاء الإجراءات القانونية المقررة كذا الأسماء والديانة والجنسية بعد اكتمال
                                            الإجراءات الخاصة بها
                                            ونورد فيما يلى قائمة بتلك الخدمات
                                        </p>
                                        <div class="accordion" id="accordionExample">
                                            <div class="accordion-item">
                                                <h2 class="accordion-header" id="headingOne">
                                                    <button class="accordion-button  shadow-sm border rounded-3 my-4"
                                                        type="button" data-bs-toggle="collapse"
                                                        data-bs-target="#collapseOne" aria-expanded="false"
                                                        aria-controls="collapseOne">
                                                        وقائع الميلاد
                                                    </button>
                                                </h2>
                                                <div id="collapseOne" class="accordion-collapse collapse show"
                                                    aria-labelledby="headingOne" data-bs-parent="#accordionExample">
                                                    <div class="accordion-body">
                                                        <ul>
                                                            <li>استخراج شهادة ميلاد أول مرة مميكنه</li>
                                                            <li>استخراج شهادة ميلاد بعد أول مرة مميكنه </li>
                                                            <li>استخراج شهادة ميلاد باللغات الاجنبية مميكنه</li>
                                                            <li>استخراج شهادة ميلاد للقنصليات بالخارج بناء على طلب
                                                                الخارجية</li>
                                                            <li>فحص طلب قيد ساقط الميلاد ومتابعة استيفاء الاوراق لحين
                                                                البت فيه</li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="accordion-item">
                                                <h2 class="accordion-header" id="headingTwo">
                                                    <button
                                                        class="accordion-button  shadow-sm border rounded-3 my-4 collapsed"
                                                        type="button" data-bs-toggle="collapse"
                                                        data-bs-target="#collapseTwo" aria-expanded="false"
                                                        aria-controls="collapseTwo">
                                                        وقائع الزواج والطلاق
                                                    </button>
                                                </h2>
                                                <div id="collapseTwo" class="accordion-collapse collapse"
                                                    aria-labelledby="headingTwo" data-bs-parent="#accordionExample">
                                                    <div class="accordion-body">
                                                        <ul>
                                                            <li>استخراج وثيقة زواج مميكنة</li>
                                                            <li>استخراج وثيقة طلاق مميكنه </li>
                                                            <li>استخراج وثيقة زواج باللغات الاجنبية مميكنه</li>
                                                            <li>استخراج وثيقة طلاق باللغات الاجنبية مميكنة</li>

                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="accordion-item">
                                                <h2 class="accordion-header" id="headingThree">
                                                    <button
                                                        class="accordion-button  shadow-sm border rounded-3 my-4 collapsed"
                                                        type="button" data-bs-toggle="collapse"
                                                        data-bs-target="#collapseThree" aria-expanded="false"
                                                        aria-controls="collapseThree">
                                                        وقائع الوفاة
                                                    </button>
                                                </h2>
                                                <div id="collapseThree" class="accordion-collapse collapse"
                                                    aria-labelledby="headingThree" data-bs-parent="#accordionExample">
                                                    <div class="accordion-body">
                                                        <ul>
                                                            <li>استخراج شهادة الوفاة المميكنة</li>
                                                            <li>استخراج شهادة الوفاة المميكنه باللغات الاجنبية </li>
                                                            <li>فحص طلب ساقط قيد الوفاة ومتابعة استيفاء الاوراق لحين
                                                                البت فيه</li>
                                                            <li>استخراج وثيقة طلاق باللغات الاجنبية مميكنة</li>

                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="accordion-item">
                                                <h2 class="accordion-header" id="headingfour">
                                                    <button
                                                        class="accordion-button  shadow-sm border rounded-3 my-4 collapsed"
                                                        type="button" data-bs-toggle="collapse"
                                                        data-bs-target="#collapsefour" aria-expanded="false"
                                                        aria-controls="collapsefour">
                                                        وقائع القيود العائلية

                                                    </button>
                                                </h2>
                                                <div id="collapsefour" class="accordion-collapse collapse"
                                                    aria-labelledby="headingfour" data-bs-parent="#accordionExample">
                                                    <div class="accordion-body">
                                                        <ul>
                                                            <li>قيد الأسرة (عائلى / فردى ) مميكن</li>
                                                            <li>قيد الأسرة ( عائلى / فردى ) مميكن باللغات الاجنبية </li>


                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="accordion-item">
                                                <h2 class="accordion-header" id="headingfive">
                                                    <button
                                                        class="accordion-button  shadow-sm border rounded-3 my-4 collapsed"
                                                        type="button" data-bs-toggle="collapse"
                                                        data-bs-target="#collapsefive" aria-expanded="false"
                                                        aria-controls="collapsefive">
                                                        اصدار بطاقة الرقم القومى </button>
                                                </h2>
                                                <div id="collapsefive" class="accordion-collapse collapse"
                                                    aria-labelledby="headingfive" data-bs-parent="#accordionExample">
                                                    <div class="accordion-body">
                                                        <ul>
                                                            <li>إصدار بطاقة الرقم القومى( اول مرة / بدل فاقد/تالف /
                                                                تغيير بيانات / أعادة تصوير )</li>
                                                            <li>تغيير /تصحيح قيود الأحوال المدنية </li>


                                                        </ul>
                                                        وفى هذا الإطار فقد تم إنشاء قاعدة قومية لبيانات كافة المواطنين
                                                        وإصدار بطاقات تحقيق الشخصية تحمل الرقم القومي وفى هذا الإطار
                                                        يوجد عدد (15) مركز إصدار لبطاقات الرقم القومي موزعة على مستوى
                                                        الجمهورية وكذا عدد (640) موقع لاصدار شهادات الميلاد المميكنة
                                                        وتصوير المواطنين لتيسير استخراج بطاقات الرقم القومي لهم وكذا
                                                        مركز لانتاج البطاقات الخام بمدينه السادس من اكتوبر.
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="accordion-item">
                                                <h2 class="accordion-header" id="headingsix">
                                                    <button
                                                        class="accordion-button  shadow-sm border rounded-3 my-4 collapsed"
                                                        type="button" data-bs-toggle="collapse"
                                                        data-bs-target="#collapsesix" aria-expanded="false"
                                                        aria-controls="collapsesix">
                                                        قيد المواليد
                                                    </button>
                                                </h2>
                                                <div id="collapsesix" class="accordion-collapse collapse"
                                                    aria-labelledby="headingsix" data-bs-parent="#accordionExample">
                                                    <div class="accordion-body">
                                                        يجب التبليغ عن المواليد خلال 15 يوما من تاريخ حدوث الولادة–وذلك
                                                        بالتقدم الى مكتب الصحة الذى حدثت فى دائرته الولادة ويكون التبليغ
                                                        عن وقائع الميلاد التى حدثت للمصريين فى الخارج خلال ثلاثة اشهر من
                                                        تاريخ حدوثها وذلك لقنصلية جمهورية مصر العربية بالخارج–او لقسم
                                                        سجل مدنى المركز الرئيسى بالقطاع عن طريق البريد الموصى عليه فى
                                                        حالة عدم وجود قنصلية ، ويكون التبليغ من نسختين على نموذج مجانى
                                                        بمكتب الصحة بمعرفة من له حق التبليغ ومعه ما يؤيد صحة الواقعة
                                                        وصحة بيانات الوالدين والوثيقة التى تثبت العلاقة الزوجية بينهما
                                                        وتحرر شهادة الميلاد عقب قيدها مباشرة وتسلم للمواطن ويقوم مكتب
                                                        الصحة بإرسال التبليغات للسجل المدنى الذى يتولى بدوره قيدها مرة
                                                        أخرى بدفتر مواليد السجل ثم إرسالها للأدارة لإدخالها بياناتها على
                                                        الحاسب الآلي وتحديد الرقم القومي للمولود
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="accordion-item">
                                                <h2 class="accordion-header" id="headingseven">
                                                    <button
                                                        class="right accordion-button  shadow-sm border rounded-3 my-4 collapsed"
                                                        type="button" data-bs-toggle="collapse"
                                                        data-bs-target="#collapseseven" aria-expanded="false"
                                                        aria-controls="collapseseven">
                                                        قيد الوفاة </button>
                                                </h2>
                                                <div id="collapseseven" class="accordion-collapse collapse"
                                                    aria-labelledby="headingseven" data-bs-parent="#accordionExample">
                                                    <div class="accordion-body">
                                                        يجب التبليغ عن الوفاة الى مكتب الصحة فى الجهة التى حدثت بها
                                                        الوفاة وذلك خلال 24 ساعة من تاريخ الوفاة او ثبوتها ويكون التبليغ
                                                        عن واقعات الوفاة التى حدثت للمواطنين المقيمين بالخارج الى
                                                        القنصلية المصرية هناك خلال ثلاثة اشهر من تاريخ حدوثها–او سجل
                                                        مدنى المركز الرئيسى بالأدارة–بالبريد الموصى عليه فى حالة عدم
                                                        وجود قنصلية لمصر هناك–ويكون التبليغ بمعرفة المكلفين به من نسختين
                                                        على النماذج المجانية المعدة لذلك اذا حدثت واقعة الوفاة لاحد
                                                        المواطنين أثناء رحلة العودة من السفر بالخارج فيكون التبليغ عن
                                                        الواقعة الى مكتب الصحة أو الجهه الصحية في ميناء الوصول خلال
                                                        24ساعة
                                                        يقوم مكتب الصحة بإصدار شهادة الوفاة عقب قيدها مباشرة وتسلم
                                                        للمواطن–ويقوم مكتب الصحة بإرسال التبليغات للسجل المدنى لقيدها
                                                        بسجلات الوفاة ثم إرسالها للأدارة لإدخال البيان بالحاسب

                                                    </div>
                                                </div>
                                            </div>
                                            <div class="accordion-item">
                                                <h2 class="accordion-header" id="headingeight">
                                                    <button
                                                        class="accordion-button  shadow-sm border rounded-3 my-4 collapsed"
                                                        type="button" data-bs-toggle="collapse"
                                                        data-bs-target="#collapseeight" aria-expanded="false"
                                                        aria-controls="collapseeight">
                                                        الرسوم المقررة
                                                    </button>
                                                </h2>
                                                <div id="collapseeight" class="accordion-collapse collapse"
                                                    aria-labelledby="headingeight" data-bs-parent="#accordionExample">
                                                    <div class="accordion-body">
                                                        <ul>
                                                            <li>(25) جنيه لقيد المواليد</li>
                                                            <li>(45) جنيه لقيد المواليد اول مرة </li>
                                                            <li>(25) جنيه لقيد الوفاة</li>
                                                            <li>(25) جنيه للقيد العائلي </li>
                                                            <li>(40) جنيه للقيد الزواج</li>
                                                            <li>(40) جنيه للقيد الطلاق </li>
                                                            <li>(50) جنيه للرقم القومي العادي</li>
                                                            <li>(125) جنيه للرقم القومي العاجلة</li>
                                                            <li>(175) جنيه للرقم القومي الخاصة</li>

                                                        </ul>
                                                    </div>
                                                </div>

                                            </div>
                                            <div class="accordion-item">
                                                <h2 class="accordion-header" id="headingnine">
                                                    <button style="text-align: right;"
                                                        class="right accordion-button  shadow-sm border rounded-3 my-4 collapsed"
                                                        type="button" data-bs-toggle="collapse"
                                                        data-bs-target="#collapsenine" aria-expanded="false"
                                                        aria-controls="collapsenine">
                                                        استخراج بطاقات الرقم القومي المميكنة


                                                    </button>
                                                </h2>
                                                <div id="collapsenine" class="accordion-collapse collapse"
                                                    aria-labelledby="headingnine" data-bs-parent="#accordionExample">
                                                    أولاً : المستندات المطلوبة لاستخراج بطاقة الرقم القومى ( اول مرة )
                                                    <div class="accordion-body">
                                                        <ul>
                                                            <li>استمارة الحصول على بطاقة الرقم القومي</li>
                                                            <li>جواز سفر لاثبات شخصية المواطن / بطاقة تحقيق الشخصية
                                                                للضامن حتى الدرجة الرابعة </li>
                                                            <li>مطلوب التأكد من تسجيل وقائع الزواج والطلاق والوفاة على
                                                                قاعدة البيانات إن وجدت</li>
                                                            <li>بالنسبة لأثبات ( طالب ) يلزم اعتماد الاستمارة من الجهة
                                                                الدراسية </li>
                                                            <li>بالنسبة للوظائف الحكومية اعتماد الاستمارة من الجهة
                                                                التابع لها</li>
                                                            <li>اعتماد المهنة من النقابة المختصة لاصحاب المهن النقابية
                                                            </li>
                                                            <li>تقديم خطاب التأمينات للعاملين بالأدارة الخاص</li>
                                                            <li>بالنسبة لأرباب المعاشات او ذوى المؤهلات العلمية
                                                                بالبطاقات الشخصية او العائلية لا يشترط إعادة اعتماد
                                                                الاستمارات اذا كان المطلوب إثبات نفس المهنة </li>
                                                            <li>إرفاق صورة ضوئية لشهادة السجل التجاري الساري وبعـد
                                                                الاطـلاع عـلى الأصل ( لاصحاب النشاط التجاري )</li>
                                                            <li>إرفاق صورة ضوئية من المؤهل الدراسي ( بعد الاطلاع على
                                                                الأصل ) فى حالة إثبات المؤهل الدراسي</li>
                                                            <li>فى حالة طلب تغيير محل الإقامة يتم إثباته بموجب عقد موثق
                                                                او إيصال كهرباء او غاز او تليفون او إقرار أحد الأقارب فى
                                                                حالة طلب تغيير محل الإقامة لديه على ان يكون هذا العنوان
                                                                مثبت ببطاقة الضامن حتى الدرجة الرابعة </li>
                                                        </ul>
                                                    </div>

                                                    ثانيا : المستندات المطلوبة لاعادة انتاج بطاقة الرقم القومى ( بدل
                                                    فاقد/ تالف ) بنفس البيانات
                                                    <ul>
                                                        <li>استمارة الحصول على بطاقة الرقم القومي ( يشار بعلامة صح عند
                                                            اختيار سبب الطلب بدل فاقد/ تالف )</li>
                                                    </ul>
                                                    ثالثا : المستندات المطلوبة لاعادة إنتاج بطاقة الرقم القومى ( تغيير
                                                    بيانات )
                                                    <ul>
                                                        <li>استمارة الحصول على بطاقة الرقم القومي ( يشار بعلامة "صح" عند
                                                            اختيار سبب الطلب تغيير بيانات )</li>
                                                        <li>تقديم المستند الدال على التغيير فى البيانات ( الوظيفة / جهة
                                                            العمل / الحالة العلمية / الحالة الاجتماعية / الديانة الخ )
                                                        </li>
                                                    </ul>
                                                    رابعا : مكان تأدية الخدمة
                                                    <ul>
                                                        <li>يتقدم المواطن بالاستمارة والمرفقات إلى اقرب منفذ لمحل إقامته
                                                            من المنافذ المنتشرة على مستوى الجمهورية </li>
                                                    </ul>
                                                    خامساً : الرسوم المقررة
                                                    <ul>
                                                        <li>(50) جنيه للاستمارة العادية</li>
                                                        <li>(125) جنيه للاستمارة المستعجلة</li>
                                                        <li>(175) جنيه استمارة رقم قومى فورية</li>
                                                        <li>( 305 ) جنية استمارة رقم قومى عاجلة فى نفس اليوم</li>
                                                    </ul>
                                                    سادسا : مـــــدة الاصدار
                                                    <ul>
                                                        <li>15 يوما للاستمارة العادية</li>
                                                        <li> 72 ساعة للاستمارة المستعجلة</li>
                                                        <li>24 ساعة للاستمارة الفورية</li>
                                                        <li>نفس اليوم لاستمارة الرقم القومى العاجلة</li>
                                                    </ul>
                                                </div>

                                            </div>
                                            <div class="accordion-item">
                                                <h2 class="accordion-header" id="headingten">
                                                    <button style="text-align: right;"
                                                        class="right accordion-button  shadow-sm border rounded-3 my-4 collapsed"
                                                        type="button" data-bs-toggle="collapse"
                                                        data-bs-target="#collapseten" aria-expanded="false"
                                                        aria-controls="collapseten">
                                                        استخراج شهادات الميلاد المميكنه

                                                    </button>
                                                </h2>
                                                <div id="collapseten" class="accordion-collapse collapse"
                                                    aria-labelledby="headingten" data-bs-parent="#accordionExample">
                                                    <div class="accordion-body">
                                                        اولاً: المستندات المطلوبة لاستخراج شهادة الميلاد المميكنه
                                                        <ul>
                                                            <li>نموذج (40) طلب الحصول على صورة وثيقة أو مستند</li>



                                                        </ul>
                                                        ثانيا : في حالة عدم الاستدلال أو اختلاف بيانات ميلاد المواطن
                                                        بالحاسب يجب على المواطن إرفاق مستخرج شهادة الميلاد الورقى لاجراء
                                                        التسجيل او التصحيح أو صورة ضوئية معتمدة
                                                        <p>ثالثا : من له الحق في استخراج شهادة الميلاد المميكنه (نفسه
                                                            /الأب/الام / الأخ / العم/ الزوجة / الأبناء / الجد / الخال)
                                                        </p>
                                                        <p>رابعا : مكان تأدية الخدمة
                                                        <ul>
                                                            <li>يتقدم المواطن إلى اقرب موقع سجل مدنى لمحل اقامته من
                                                                المواقع المنتشرة على مستوى الجمهورية </li>
                                                        </ul>
                                                        خامساً : الرسوم المقررة
                                                        <ul>
                                                            <li>(45) جنيه لشهادة الميلاد المميكنه لاول مرة </li>
                                                            <li>(25) جنيه لشهادة الميلاد المميكنه تانى مرة</li>
                                                        </ul>
                                                        سادسا : مـــــدة الاصـــدار
                                                        <ul>
                                                            <li>في نفس يوم تقديم الطلب</li>
                                                        </ul>
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="accordion-item">
                                                <h2 class="accordion-header" id="headingelven">
                                                    <button
                                                        class="right accordion-button  shadow-sm border rounded-3 my-4 collapsed"
                                                        type="button" style="text-align:right;"
                                                        data-bs-toggle="collapse" data-bs-target="#collapseeleven"
                                                        aria-expanded="false" aria-controls="collapseeleven">
                                                        استخراج بطاقات الرقم القومي وشهادات الميلاد المميكنه عن طريق
                                                        الإنترنت

                                                    </button>
                                                </h2>
                                                <div id="collapseeleven" class="accordion-collapse collapse"
                                                    aria-labelledby="headingeleven" data-bs-parent="#accordionExample">
                                                    <div class="accordion-body">
                                                        اولاً : كيفية تأدية الخدمة
                                                        <ul>
                                                            <li> يقوم المواطن بعمل تسجيل الدخول على بوابة وزارة الداخلية
                                                                من خلال الرابط
                                                                https://cso.moi.gov.eg
                                                            </li>
                                                            <li>يقوم بأنشاء الحساب الخاص به على بوابة وزارة الداخلية
                                                                وذلك ( بالرقم القومى و رقم التليفون الخاص به) للحصول على
                                                                الخدمات الالكترونية المقدمة عبر موقع الوزارة على شبكة
                                                                المعلومات الدولية </li>
                                                            <li>يقوم بأنشاء الحساب الخاص به على بوابة وزارة الداخلية
                                                                وذلك ( بالرقم القومى و رقم التليفون الخاص به) للحصول على
                                                                الخدمات الالكترونية المقدمة عبر موقع الوزارة على شبكة
                                                                المعلومات الدولية</li>
                                                            <li>يقوم المواطن طالب الخدمة بقراءة شروط الخدمة اولاً و
                                                                الموافقة عليها ثم يقوم بتحديد نوع الخدمة المراد الحصول
                                                                عليه وتدوين بيانات طالب الخدمة والمستفيد</li>
                                                            <li>السداد من خلال البطاقة الائتمانية او كاش (فورى)</li>
                                                        </ul>
                                                        ثانيا : الوثائق التى يمكن استخراجها بأسلوب الحكومة الإلكترونية
                                                        من خلال الإنترنت هي :
                                                        <ul>

                                                            <li>شهادة ميلاد مميكنه أول مرة 80 جنية</li>
                                                            <li>شهادة ميلاد مميكنة 65 جنية</li>
                                                            <li>شهادة وفاة مميكنة 65 جنية</li>
                                                            <li>وثيقة زواج مميكنه 70 جنية</li>
                                                            <li>وثيقة طلاق مميكنة 70 جنية</li>
                                                            <li>قيد عائلى مميكن تانى مرة 65 جنية</li>
                                                            <li>قيد فردى مميكن 65 جنية </li>
                                                            <li>بطاقة رقم قومى ( بدل فاقد/ تالف ) 175 جنية </li>
                                                            <li>بطاقة رقم قومى اول مرة ( كبار السن/ذوى </li>
                                                            <li>الاحتياجات الخاصة) 175 جنية </li>
                                                            <li>استمارة رقم قومى عادية 50 جنية</li>
                                                            <li>استمارة رقم قومى مستعجلة 125 جنية</li>
                                                            <li>استمارة رقم قومى فورية 175 جنية</li>

                                                        </ul>

                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="tab-pane fade" id="v-pills-messages" role="tabpanel"
                                        aria-labelledby="v-pills-messages-tab" tabindex="0">

                                        <h1 class="blueFont py-3"> الرقم القومي</h1>
                                        <h1 class="blueFont py-3"> تعريف عام بالمشروع</h1>
                                        يعد تحديث نظام الأحوال المدنية في مصر من متطلبات بناء مجتمع عصري يسعى لتحقيق
                                        التنمية الاقتصادية والأمن الاجتماعي من خلال تخصيص رقم قومي لكل مواطن مصري لا
                                        يتكرر منذ مولده وحتى بعد وفاته. ولقد حقق قطاع الأحوال المدنية نجاحا ملموسا
                                        ومشهودا حتى الآن في إنشاء قاعدة بيانات متكاملة باستخدام أحدث وسائل تكنولوجيا
                                        المعلومات وإدارة قواعد البيانات حيث تم ميكنة سجلات الوقائع الورقية الخاصة
                                        بالمواطنين والمتوافرة في العديد من جهات الدولة (قطاع الأحوال المدنية - دار
                                        المحفوظات - أجهزة المحليات - وزارة الصحة) لتشمل الوقائع التالية:
                                        <ul>
                                            <li>
                                                قاعدة بيانات المواليد منذ عام 1900
                                            </li>
                                            <li>قاعدة بيانات الوفيات منذ عام 1900</li>
                                            <li>قاعدة بيانات الزواج منذ عام 1962</li>
                                            <li>قاعدة بيانات الطلاق منذ عام 1962</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import Path from '@/components/Path.vue';
export default {
    name: 'AboutComp',
    components: { Path },
    created() {
        window.scrollTo({ top: 0, behavior: "smooth" });
    },
    data() {
        return { play: true }
    },
    methods: {
        ToAbout() {
            this.$router.push({ name: 'about' })
        },
        LightBox() {
            this.play = true;
            let element = document.querySelector('.lightbox');
            element.classList.add("active");

        },
        CloseDiv() {
            this.play = false;
            let element = document.querySelector('.lightbox');
            element.classList.remove("active");

        }
    }
}


</script>
<style>
.lightbox {
    position: fixed;
    z-index: 1000;
    top: 0;
    right: 0;
    left: 0;
    max-width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.8);
    display: none;
}

.active {
    display: flex;
    justify-content: center;
    align-items: center;
}
</style>